// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__xXFwB","row":"Node_row__2ir7T","label":"Node_label__2Xwg6","footer":"Node_footer__1oca4"};